export const blockIconsActionList = (
	<span className='material-symbols-outlined'>list</span>
);
